import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminIndex() {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? 'dashboard' : 'login'} replace />;
}
